import { ApiService, ApiServiceInterface } from "../../../../../core";
import { ISubscriptionsReportData } from "../../../site/impl/interfaces/factories";
import { SubscriptionsReportPageController } from "../../core/controllers";

export class SubscriptionsReportControllerImpl implements SubscriptionsReportPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async getSubscriptionsReportData(parameters: string): Promise<ISubscriptionsReportData> {
        try {
            const response = await this.api.get(`/manager-report?type=subscriptions&${parameters}`);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }
}